import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDownloadLogs } from '../../hooks/react-query/useAdmin';
import { Mapper } from '../../utils/user/mapper';
import { Table } from '../../components/ui/Table';
import { PageTitle } from '../../components/ui';
import { HeaderToolBar } from '../../components/elements/headerToolBar';
import Pagination from '../../components/elements/pagination/pagination';

import {
  exportToFile,
  generatePdfDocument,
} from '../../utils/importDriver/funtions';
import { TableSkeletion } from '../../components/elements/skeletions';
import Container from '../../components/elements/container';
import { LeftArrow } from '../../icons';
import {
  TableBodyComponent,
  TableHeadersComponent,
} from '../../components/admin/table';
import { downloadDocument } from '../../transactions/download/download';
import { DateRangePicker } from '../../components/elements/datePicker/datePicker';
import { NoDataFound } from '../../components/elements/noDataFound';
import Loader from '../../components/elements/loader';
import DownloadLogsPageTitle from '../../components/admin/downloadLogsPageTitle';
import { DownloadLogsHeaderToolBar } from '../../components/admin/downloadLogsHeaderToolBar';

const DownloadLogs = () => {
  const navigate = useNavigate();

  const [logs, setLogs] = useState();
  const [openColumnListModal, setCoumnListModal] = useState(false);
  const [selectedColumns, setSavedColumns] = useState([]); //
  const [searchText, setSearchText] = useState('');

  const [dateRange, setDateRange] = useState({});

  const [filterState, setFilterState] = useState({
    length: 25,
    orderBy: '',
    search: '',
    page: 1,
    orderType: 'asc',
  });

  const { data: logsData, isLoading } = useDownloadLogs(filterState, dateRange);

  useEffect(() => {
    if (logsData && logsData.pages && logsData.pages[0].data) {
      setLogs(Mapper(logsData.pages[0], 'downloadLogs'));
    }
  }, [logsData]);

  const handleExport = (type) => {
    if (type === 'pdf') {
      generatePdfDocument(logs, 'Download Logs');
    } else {
      exportToFile(logs, type, 'downloadLogs');
    }
  };

  const handleSortOrder = (item) => {
    let orderBy = item.name;
    let orderType = 'asc';
    if (item.name !== filterState?.orderBy) {
      orderBy = item.name;
    } else {
      orderType = filterState.orderType === 'asc' ? 'desc' : orderType;
    }

    setFilterState((prev) => ({ ...prev, orderType, orderBy, page: 1 }));
  };

  const handleSearch = (searchKey) => {
    setFilterState((prev) => ({ ...prev, search: searchKey, page: 1 }));
  };

  const handlePagination = (pageNum) => {
    setFilterState((prev) => ({ ...prev, page: pageNum }));
  };

  const handleColumnSave = (columns) => {
    setSavedColumns(columns);
    setCoumnListModal(false);
  };

  const handlePerPageDataFetch = (value) => {
    setFilterState((prev) => ({ ...prev, length: value }));
  };

  const handleDownloadDocument = (data, url) => {
    downloadDocument(`${url}${data.id}`);
  };

  const handleApplyClick = (downloadDate) => {
    const range = {};
    if (downloadDate.from && downloadDate.to) {
      range['downloadFrom'] = downloadDate.from;
      range['downloadTo'] = downloadDate.to;
    } else if (downloadDate.from && !downloadDate.to) {
      range['downloadFrom'] = downloadDate.from;
      range['downloadTo'] = downloadDate.from;
    } else if (!downloadDate.from && downloadDate.to) {
      range['downloadFrom'] = downloadDate.to;
      range['downloadTo'] = downloadDate.to;
    }
    setSearchText('');
    setFilterState({
      length: 25,
      orderBy: '',
      search: '',
      page: 1,
      orderType: 'asc',
    });
    setDateRange({ ...dateRange, ...range });
  };

  const handleInvoiceApplyClick = (invoiceDate) => {
    const range = {};
    if (invoiceDate.from && invoiceDate.to) {
      range['invoicesFrom'] = invoiceDate.from;
      range['invoicesTo'] = invoiceDate.to;
    } else if (invoiceDate.from && !invoiceDate.to) {
      range['invoicesFrom'] = invoiceDate.from;
      range['invoicesTo'] = invoiceDate.from;
    } else if (!invoiceDate.from && invoiceDate.to) {
      range['invoicesFrom'] = invoiceDate.to;
      range['invoicesTo'] = invoiceDate.to;
    }
    setSearchText('');
    setFilterState({
      length: 25,
      orderBy: '',
      search: '',
      page: 1,
      orderType: 'asc',
    });
    setDateRange({ ...dateRange, ...range });
  };

  const handleClearClick = () => {
    let range = {};
    if (dateRange.invoicesFrom) {
      range['invoicesFrom'] = dateRange.invoicesFrom;
    }
    if (dateRange.invoicesTo) {
      range['invoicesTo'] = dateRange.invoicesTo;
    }
    setDateRange(range);
  };

  const handleInvoiceClearClick = () => {
    let range = {};
    if (dateRange.downloadFrom) {
      range['downloadFrom'] = dateRange.downloadFrom;
    }
    if (dateRange.downloadTo) {
      range['downloadTo'] = dateRange.downloadTo;
    }
    setDateRange(range);
  };

  if (isLoading && !logs) {
    return (
      <Container className="max-lg:px-0">
        <TableSkeletion />
      </Container>
    );
  }

  if (!logs || !logs.data) {
    return (
      <Container>
        <NoDataFound />
      </Container>
    );
  }

  return (
    <>
      {isLoading && logs && <Loader />}
      <Container className="py-10 flex flex-col gap-6 overflow-y-auto max-h-[88vh] max-lg:px-0">
        <DownloadLogsPageTitle
          wrapperClassName="flex-col max-lg:px-5"
          title={
            <div className="flex justify-between">
              <div className="flex max-lg:gap-x-2 items-center">
                <button className='lg:p-2' onClick={() => navigate('/dashboard')}>
                  <LeftArrow width={24} height={24} />
                </button>
                <h2>Download Logs</h2>
              </div>
              <div className="flex gap-2">
                <DateRangePicker
                  /*  date={date}
                  setDate={setDate} */
                  selected={{
                    from: dateRange['downloadFrom'],
                    to: dateRange['downloadTo'],
                  }}
                  title="Χρονική Περίοδος Λήψεων"
                  iconClass="stroke-black"
                  className="bg-transparent text-black border boder-black max-lg:hidden"
                  handleApplyClick={handleApplyClick}
                  handleClearClick={handleClearClick}
                  showApplyButton={true}
                  showfromLocal={true}
                  id="downloadDateRange"
                />
                <DateRangePicker
                  /*  date={invoiceDate}
                  setDate={setInvoiceTimePeriod} */
                  selected={{
                    from: dateRange['invoicesFrom'],
                    to: dateRange['invoicesTo'],
                  }}
                  title="Χρονική Περίοδος Παραστατικών"
                  iconClass="stroke-black"
                  className="bg-transparent text-black border boder-black max-lg:hidden"
                  handleApplyClick={handleInvoiceApplyClick}
                  handleClearClick={handleInvoiceClearClick}
                  showApplyButton={true}
                  showfromLocal={true}
                  id="invoiceDateRange"
                />
              </div>
            </div>
          }
          endComponent={
            <DownloadLogsHeaderToolBar
              dataPerPageCount={filterState?.length}
              openColumnListModal={openColumnListModal}
              handleSearch={handleSearch}
              searchTerm={filterState.search}
              configurations={logs}
              columnList={logs?.columns}
              handleExport={handleExport}
              selectedColumns={selectedColumns}
              handleColumnSave={handleColumnSave}
              handleColumnListClick={(value) => setCoumnListModal(value)}
              handlePerPageDataFetch={handlePerPageDataFetch}
              handleApplyClick={handleApplyClick}
              handleInvoiceApplyClick={handleInvoiceApplyClick}
              handleClearClick={handleClearClick}
              handleInvoiceClearClick={handleInvoiceClearClick}
              searchText={searchText}
              handleSearchText={(value) => setSearchText(value)}
            />
          }
        />
        <Table wrapperClassName="p-2 lg:p-4 scrollbar overflow-auto max-lg:rounded-none max-lg:min-h-[250px]">
          <TableHeadersComponent
            selectedColumns={selectedColumns}
            tableData={logs}
            handleSortOrder={handleSortOrder}
          />
          <TableBodyComponent
            tableData={logs}
            selectedColumns={selectedColumns}
            handleAction={handleDownloadDocument}
          />
        </Table>

        <Pagination
          currentPage={logs?.pagination?.current_page}
          totalCount={logs?.records?.total}
          from={logs?.records.from}
          to={logs?.records.to}
          pageSize={filterState.length || 25}
          onPageChange={handlePagination}
        />
      </Container>
    </>
  );
};

export default DownloadLogs;
